import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/css/styles.css"; // Your styles
import "bootstrap/dist/css/bootstrap.min.css";  // Bootstrap styles

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Sidebar starts closed

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`d-flex ${isSidebarOpen ? "" : "toggled"}`} id="wrapper">
      {/* Sidebar */}
      <div className={`bg-dark border-right ${isSidebarOpen ? "show" : "collapse"}`} id="sidebar-wrapper">

        <div className="list-group list-group-flush">
          <Link to="/" className="list-group-item list-group-item-action text-white bg-dark">Home</Link>
          <Link to="/charts" className="list-group-item list-group-item-action text-white bg-dark">Charts</Link>
          <Link to="/tables" className="list-group-item list-group-item-action text-white bg-dark">Tables</Link>
        </div>
      </div>

      {/* Page Content */}
      <div id="page-content-wrapper">
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom d-flex justify-content-between align-items-center p-3 w-100">
          <button 
            className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center" 
            onClick={toggleSidebar}
            onMouseDown={(e) => e.target.style.boxShadow = "0 2px 3px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.15)"}
            onMouseUp={(e) => e.target.style.boxShadow = "0 3px 3px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.15)"}
          >
            {/* <kbd>&#9776;</kbd> */}
            <span>&#8801;</span> 
          </button>
          <div style={{ width: "100px" }}></div>
          <h1 className="text-center flex-grow-1 m-0 fw-bold"> ZAMBODI DATA SYSTEMS </h1>
          <div style={{ width: "100px" }}></div> {/* Placeholder for spacing */}
        </nav>

        {/* Main Content */}
        <div className="container-fluid">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
